import React from 'react';
import { Minus, Plus } from 'lucide-react';

/** Seletor de quantidade [ - n + ] (equipe e família). */
export function Stepper({ value, onChange, max, min = 0, testid, disabled }) {
  const v = Number(value || 0);
  const btn = 'flex h-9 w-9 items-center justify-center rounded-full border bg-white transition-colors hover:bg-[#F5EEFA] disabled:opacity-40';
  return (
    <span className="inline-flex items-center gap-2" data-testid={testid}>
      <button type="button" className={btn} style={{ borderColor: '#E4D8EE' }} disabled={disabled || v <= min} onClick={() => onChange(v - 1)} aria-label="Diminuir" data-testid={`${testid}-menos`}><Minus className="h-4 w-4" /></button>
      <b className="w-7 text-center text-[15px] tabular-nums" data-testid={`${testid}-valor`}>{v}</b>
      <button type="button" className={btn} style={{ borderColor: '#E4D8EE' }} disabled={disabled || (max != null && v >= max)} onClick={() => onChange(v + 1)} aria-label="Aumentar" data-testid={`${testid}-mais`}><Plus className="h-4 w-4" /></button>
    </span>
  );
}
